// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#header {
  position: fixed;
  width: 220px;
}

#header .pro-sidebar {
  height: 100vh;
  position: absolute;
  width: 220px;
}

#header .closemenu {
  color: #000;
  position: absolute;
  right: 0;
  z-index: 9999;
  line-height: 20px;
  border-radius: 50%;
  font-weight: bold;
  font-size: 22px;
  top: 55px;
  cursor: pointer;
}

#header .pro-sidebar {
  width: 100%;
  min-width: 100%;
}

#header .pro-sidebar.collapsed {
  width: 50px;
  min-width: 50px;
}

#header .pro-sidebar-inner {
  background-color: white;
  box-shadow: -1px 7px 5px 1px rgba(0, 0, 0, 0.15)
  /* //7px 20px 15px 3px rgba(0, 0, 0, 0.15); */
}

#header .pro-sidebar-inner .pro-sidebar-layout {
  overflow-y: hidden;
}

/* #header .pro-sidebar-inner .pro-sidebar-layout .logotext p {
    font-size: 20px;
    padding: 0 20px;
    color: #000;
    font-weight: bold;
  } */
#header .pro-sidebar-inner .pro-sidebar-layout ul {
  padding: 0 5px;
}

#header .pro-sidebar-inner .pro-sidebar-layout ul .pro-inner-item {
  color: #000;
  margin: 10px 0px;
  font-weight: bold;
}

#header .pro-sidebar-inner .pro-sidebar-layout ul .pro-inner-item .pro-icon-wrapper {
  background-color: transparent;
}

#header .pro-sidebar-inner .pro-sidebar-layout ul .pro-inner-item .pro-icon-wrapper .pro-item-content {
  color: #000;
}

#header .pro-sidebar-inner .pro-sidebar-layout .active {
  background-image: linear-gradient(0deg, #7916ff 0%, #7916ff 100%);
  width: 35px;
  height: 35px;
  border-radius: 4px;

}

#header .logo {
  padding: 20px;
}

@media only screen and (max-width: 720px) {
  html {
    overflow: hidden;
  }
}


.pro-sidebar .pro-menu .pro-menu-item>.pro-inner-item>.pro-icon-wrapper .pro-icon {
  display: flex;
  height: 100%;
  align-items: left;
  justify-content: left;
  font-size: 20px;
  color: #8a55a9;
  text-align: left
}

.pro-sidebar {
  color: #8a55a9;
  font-size: 26px;
  align-items: left;
  justify-content: left;
  font-size: 28px;
  text-align: left
}

.pro-sidebar .pro-menu .pro-menu-item>.pro-inner-item {
  position: relative;
  display: flex;
  align-items: start;
  padding: 8px 35px 8px 8px;
  cursor: pointer;
}

.logotext {
  padding: 10px 15px 10px 15px;
}

.pro-sidebar .pro-menu .pro-menu-item>.pro-inner-item>.pro-icon-wrapper {
  margin-right: 10px;
  font-size: 20px;
  width: 26px;
  min-width: 26px;
  height: 20px;
  line-height: 27px;
  text-align: center;
  display: inline-block;
}
.pro-sidebar > .pro-sidebar-inner > .pro-sidebar-layout .pro-sidebar-content {
  flex-grow: 0.8;
}

.actimenu {
  color: #ffffff;
}

.hamberger {
  color: #8a55a9;
  font-size: 25px;
}

.MuiAppBar-root {
  height: 58px;
  background-color: #ffffff !important;
  box-shadow: -3px 0px 8px 0px rgba(0, 0, 0, 0.15) !important;
  position:fixed;
}

.rightmenu{
  color: #8a55a9;
  position: initial;
  font-size: 25px;
  margin: -39px 13px 0px 0;
  justify-content: end;
  display: flex;
}`, "",{"version":3,"sources":["webpack://./src/common/header/Header.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,+CAA+C;EAC/C,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;;;KAKK;AACL;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iEAAiE;EACjE,WAAW;EACX,YAAY;EACZ,kBAAkB;;AAEpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;;AAGA;EACE,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd;AACF;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,eAAe;EACf;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,oCAAoC;EACpC,2DAA2D;EAC3D,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,wBAAwB;EACxB,oBAAoB;EACpB,aAAa;AACf","sourcesContent":["#header {\r\n  position: fixed;\r\n  width: 220px;\r\n}\r\n\r\n#header .pro-sidebar {\r\n  height: 100vh;\r\n  position: absolute;\r\n  width: 220px;\r\n}\r\n\r\n#header .closemenu {\r\n  color: #000;\r\n  position: absolute;\r\n  right: 0;\r\n  z-index: 9999;\r\n  line-height: 20px;\r\n  border-radius: 50%;\r\n  font-weight: bold;\r\n  font-size: 22px;\r\n  top: 55px;\r\n  cursor: pointer;\r\n}\r\n\r\n#header .pro-sidebar {\r\n  width: 100%;\r\n  min-width: 100%;\r\n}\r\n\r\n#header .pro-sidebar.collapsed {\r\n  width: 50px;\r\n  min-width: 50px;\r\n}\r\n\r\n#header .pro-sidebar-inner {\r\n  background-color: white;\r\n  box-shadow: -1px 7px 5px 1px rgba(0, 0, 0, 0.15)\r\n  /* //7px 20px 15px 3px rgba(0, 0, 0, 0.15); */\r\n}\r\n\r\n#header .pro-sidebar-inner .pro-sidebar-layout {\r\n  overflow-y: hidden;\r\n}\r\n\r\n/* #header .pro-sidebar-inner .pro-sidebar-layout .logotext p {\r\n    font-size: 20px;\r\n    padding: 0 20px;\r\n    color: #000;\r\n    font-weight: bold;\r\n  } */\r\n#header .pro-sidebar-inner .pro-sidebar-layout ul {\r\n  padding: 0 5px;\r\n}\r\n\r\n#header .pro-sidebar-inner .pro-sidebar-layout ul .pro-inner-item {\r\n  color: #000;\r\n  margin: 10px 0px;\r\n  font-weight: bold;\r\n}\r\n\r\n#header .pro-sidebar-inner .pro-sidebar-layout ul .pro-inner-item .pro-icon-wrapper {\r\n  background-color: transparent;\r\n}\r\n\r\n#header .pro-sidebar-inner .pro-sidebar-layout ul .pro-inner-item .pro-icon-wrapper .pro-item-content {\r\n  color: #000;\r\n}\r\n\r\n#header .pro-sidebar-inner .pro-sidebar-layout .active {\r\n  background-image: linear-gradient(0deg, #7916ff 0%, #7916ff 100%);\r\n  width: 35px;\r\n  height: 35px;\r\n  border-radius: 4px;\r\n\r\n}\r\n\r\n#header .logo {\r\n  padding: 20px;\r\n}\r\n\r\n@media only screen and (max-width: 720px) {\r\n  html {\r\n    overflow: hidden;\r\n  }\r\n}\r\n\r\n\r\n.pro-sidebar .pro-menu .pro-menu-item>.pro-inner-item>.pro-icon-wrapper .pro-icon {\r\n  display: flex;\r\n  height: 100%;\r\n  align-items: left;\r\n  justify-content: left;\r\n  font-size: 20px;\r\n  color: #8a55a9;\r\n  text-align: left\r\n}\r\n\r\n.pro-sidebar {\r\n  color: #8a55a9;\r\n  font-size: 26px;\r\n  align-items: left;\r\n  justify-content: left;\r\n  font-size: 28px;\r\n  text-align: left\r\n}\r\n\r\n.pro-sidebar .pro-menu .pro-menu-item>.pro-inner-item {\r\n  position: relative;\r\n  display: flex;\r\n  align-items: start;\r\n  padding: 8px 35px 8px 8px;\r\n  cursor: pointer;\r\n}\r\n\r\n.logotext {\r\n  padding: 10px 15px 10px 15px;\r\n}\r\n\r\n.pro-sidebar .pro-menu .pro-menu-item>.pro-inner-item>.pro-icon-wrapper {\r\n  margin-right: 10px;\r\n  font-size: 20px;\r\n  width: 26px;\r\n  min-width: 26px;\r\n  height: 20px;\r\n  line-height: 27px;\r\n  text-align: center;\r\n  display: inline-block;\r\n}\r\n.pro-sidebar > .pro-sidebar-inner > .pro-sidebar-layout .pro-sidebar-content {\r\n  flex-grow: 0.8;\r\n}\r\n\r\n.actimenu {\r\n  color: #ffffff;\r\n}\r\n\r\n.hamberger {\r\n  color: #8a55a9;\r\n  font-size: 25px;\r\n}\r\n\r\n.MuiAppBar-root {\r\n  height: 58px;\r\n  background-color: #ffffff !important;\r\n  box-shadow: -3px 0px 8px 0px rgba(0, 0, 0, 0.15) !important;\r\n  position:fixed;\r\n}\r\n\r\n.rightmenu{\r\n  color: #8a55a9;\r\n  position: initial;\r\n  font-size: 25px;\r\n  margin: -39px 13px 0px 0;\r\n  justify-content: end;\r\n  display: flex;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
